import { useEffect } from 'react';
import { ExternalSecondaryTradeDetails } from 'src/apis/remit-reporting/types';
import { useAxios } from 'src/hooks/use-axios';

export function useExternalTrade(externalTradeId: string) {
  const trade = useAxios(
    (axios, signal) =>
      axios.request<ExternalSecondaryTradeDetails>({
        signal,
        url: `${PRISMA_CONFIG.remitReporting}/api/platform/external-secondary-trades/${externalTradeId}`,
        method: 'GET',
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    trade.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalTradeId]);

  return trade;
}
